import React from 'react';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';

import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useGetProcessById } from 'src/hooks/processes/get-process-by-id.hook';

import { EditProcessForm } from './edit-process-form';

import { IProcessTask } from 'src/pages/tasks-manager/task-manager.interfaces';
import { IProcess } from '../../processes.interfaces';

const EditProcess = ({
  processData,
  onCancel,
}: {
  processData?: IProcess;
  onCancel: () => void;
}) => {
  const { process, loading } = useGetProcessById(processData?._id);

  const { processTasks, ...rest } = process;

  const tasks = !isEmpty(processTasks)
    ? processTasks.map((processTask: IProcessTask) => ({
        ...pick(processTask, [
          '_id',
          'title',
          'details',
          'status',
          'responsiblePersonsIds',
          'jobId',
          'type',
          'companyId',
          'departmentId',
          'description',
          'checklist',
          'assignTo',
          'createdBy',
        ]),
        key: uuidv4(),
        ...(processTask?.dueTo && {
          dueTo: moment(processTask.dueTo),
        }),
      }))
    : [];

  if (loading) {
    return <Loader />;
  }

  return <EditProcessForm process={rest} tasks={tasks} onCancel={onCancel} />;
};

export default EditProcess;
